module.exports = __webpack_public_path__ + "media/explosionCrunch_000.e99cd340.ogg";